"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleDefinitionIDSchema = exports.PermissionDefinitionIDSchema = exports.PermissionEntityTypeSchema = void 0;
const zod_1 = require("zod");
const permissionEntityTypes = ['REGION', 'PROPERTY', 'SYSTEM', 'USER'];
exports.PermissionEntityTypeSchema = zod_1.z.enum(permissionEntityTypes);
exports.PermissionDefinitionIDSchema = zod_1.z.string();
exports.RoleDefinitionIDSchema = zod_1.z.number();
//# sourceMappingURL=admin.js.map